<template>
  <div class="productQuotationApplicationAdd container">
    <el-row>
      <el-button size="mini" class="btn" type="primary" @click="$router.go(-1)">{{$t("common.close")}}</el-button>
    </el-row>

    <el-table :data="tableDetail" border highlight-current-row ref="applyProductTableDataRef" style="margin-top:5px">
      <el-table-column show-overflow-tooltip sortable prop="sourcingNo" label="定点单据编号" min-width="140px">
        <template slot-scope="scope">
          <el-link v-if="emplFlag == 'MCD'" type="primary" @click="openQuotationApplyDetail(scope.row)"> {{scope.row.sourcingNo}} </el-link>
          <span v-if="emplFlag != 'MCD'">{{scope.row.sourcingNo}}</span>
        </template>
      </el-table-column>
      <el-table-column show-overflow-tooltip sortable prop="tmSupplierId" label="线路承运商" min-width="120px">
        <template slot-scope="scope">
          {{scope.row.tmSupplierId | ic("BASE",'CARRIER')}}
        </template>
      </el-table-column>
      <el-table-column show-overflow-tooltip sortable prop="eightBitCode" label="8位码" min-width="130px"></el-table-column>
      <el-table-column show-overflow-tooltip sortable prop="productPrice" label="产品运费（不含税）" min-width="100px"></el-table-column>
      <el-table-column show-overflow-tooltip sortable prop="effectiveBeginDate" label="产品有效开始日期" width="200">
        <template slot-scope="scope">{{scope.row.effectiveBeginDate | dateFormatFilter("YYYY-MM-DD")}}</template>
      </el-table-column>
      <el-table-column show-overflow-tooltip sortable prop="isSpecialFreight" label="非标准线路运费" min-width="150px">
        <template slot-scope="scope">
          {{scope.row.isSpecialFreight|ic("COMMON","YES_NO")}}
        </template>
      </el-table-column>
      <el-table-column show-overflow-tooltip sortable prop="remarks" :label="$t('common.remarks')" min-width="100px"></el-table-column>
    </el-table>

  </div>
</template>
<script>
import { getfreightsHistories } from "@/api/base-data/materialPriceData";
export default {
  name: "materialPriceHistory",
  data() {
    return {
      tmProductFreightId: '',
      tableDetail: [],
      emplFlag: null,
    };
  },
  created() {
    this.tmProductFreightId = this.$route.query.tmProductFreightId;
    this.eightBitCode = this.$route.query.eightBitCode;
    this.initData(this.$route.query.tmProductFreightId, this.$route.query.eightBitCode);
    this.emplFlag = localStorage.getItem("ms_emplFlag");
  },
  methods: {
    initData: function (id, code) {
      let that = this
      getfreightsHistories(id).then(res => {
        console.log(res)
        for (var i = 0; i < res.data.length; i++) {
          res.data[i].eightBitCode = code
        }
        this.tableDetail = res.data
      });
    },
    //详情
    openQuotationApplyDetail: function (row) {
      if (this.actionCheck.actionCheck('Sourcing-productSearch') === false) {
        this.$message.error(this.$t('common.noPermission'))
        return false
      }
      this.$router.push({
        path: `/sourcingByProduct-detail`,
        query: {
          sourcingNo: row.sourcingNo,
        }
      });
    },
  }
};
</script>
<style scoped lang="scss">
.productQuotationApplicationAdd {
  .toolsBox {
    margin-bottom: 10px;
  }
  .a-link {
    text-decoration: underline;
  }
  .topform {
    margin-top: 20px;
  }
}
</style>
